import initCarousel from '../helpers/carousel';
import { unitlessBreakpoints } from '../helpers/breakpoints';

export default class DynamicVideoTestimonials {
  constructor(section) {
    this.el = section.el;
    this.section = section;

    initCarousel(
      this.el,
      {
        perPage: 1,
        type: 'loop',
        autoplay: false,
        arrows: false,
        pagination: false,
        gap: '16px',
        padding: {
          left: 32,
          right: 32,
        },
        mediaQuery: 'min',
        breakpoints: {
          [unitlessBreakpoints.xs]: {
            perPage: 2,
            padding: {
              left: 16,
              right: 16,
            },
          },
          [unitlessBreakpoints.md]: {
            perPage: 3,
          },
          [unitlessBreakpoints.lg]: {
            perPage: 4,
            padding: 0,
          },
          [unitlessBreakpoints.xl]: {
            perPage: 5,
          },
        },
      },
      true,
    );
  }
}
